/*
 * HelpMenuPanel Messages
 *
 * This contains all the text for the HelpMenuPanel component.
 */
import { defineMessages } from 'react-intl';

import helpContext from 'constants/helpContext';

const scope = 'app.workspace.helpMenu';

export default defineMessages({
  eTextHelp: {
    id: `${scope}.eTextHelp`,
    defaultMessage: 'eText Help',
  },
  eTextHelpTitle: {
    id: `${scope}.eTextHelpTitle`,
    defaultMessage: 'Visit the following Bronte course for full documentation on building eText courses:',
  },
  eTextHelpLink: {
    id: `${scope}.eTextHelpLink`,
    defaultMessage: 'Bronte eText Documentation',
  },
  iLabsHelp: {
    id: `${scope}.iLabsHelp`,
    defaultMessage: 'iLabs Help',
  },
  helpButton: {
    id: `${scope}.helpButton`,
    defaultMessage: 'Help, feedback, and support',
  },
  aiButton: {
    id: `${scope}.aiButton`,
    defaultMessage: 'Open AI assistant',
  },
  campusSupportButton: {
    id: `${scope}.campusSupportButton`,
    defaultMessage: 'Open Campus Support',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close',
  },
  helpTitle: {
    id: `${scope}.helpTitle`,
    defaultMessage: 'How can we help you?',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  viewMore: {
    id: `${scope}.viewMore`,
    defaultMessage: 'View More',
  },
  similar: {
    id: `${scope}.similar`,
    defaultMessage: 'Similar',
  },
  articles: {
    id: `${scope}.articles`,
    defaultMessage: 'Articles',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Back',
  },
  [helpContext.HOME]: {
    id: `${scope}.home`,
    defaultMessage: 'Home',
  },
  [helpContext.PROJECTS]: {
    id: `${scope}.projects`,
    defaultMessage: 'Projects',
  },
  [helpContext.OPEN_PROJECT]: {
    id: `${scope}.openProject`,
    defaultMessage: 'Project',
  },
  [helpContext.COURSE_BUILDER]: {
    id: `${scope}.courseBuilder`,
    defaultMessage: 'Course',
  },
  [helpContext.COURSE_BUILDER_DESIGN]: {
    id: `${scope}.cbDesign`,
    defaultMessage: 'Course Design',
  },
  [helpContext.COURSE_BUILDER_COMPETENCY]: {
    id: `${scope}.cbCompetency`,
    defaultMessage: 'Course Competency',
  },
  [helpContext.COURSE_BUILDER_SCORING]: {
    id: `${scope}.cbScoring`,
    defaultMessage: 'Course Scoring',
  },
  [helpContext.LESSON_BUILDER]: {
    id: `${scope}.lessonBuilder`,
    defaultMessage: 'Lesson',
  },
  [helpContext.LESSON_BUILDER_DESIGN]: {
    id: `${scope}.lbDesign`,
    defaultMessage: 'Lesson Design',
  },
  [helpContext.LESSON_BUILDER_COMPETENCY]: {
    id: `${scope}.lbCompetency`,
    defaultMessage: 'Lesson Competency',
  },
  [helpContext.LESSON_BUILDER_SCORING]: {
    id: `${scope}.lbScoring`,
    defaultMessage: 'Lesson Scoring',
  },
  [helpContext.SCREEN_EDITOR]: {
    id: `${scope}.screenEditor`,
    defaultMessage: 'Screen Editor',
  },
  [helpContext.KNOWLEDGE]: {
    id: `${scope}.knowledge`,
    defaultMessage: 'Knowledge',
  },
  [helpContext.CLASSES]: {
    id: `${scope}.classes`,
    defaultMessage: 'Classes',
  },
});
